// Long-form SEO content per category (shown at bottom of /category/:slug pages).

const COMMON_RISKS = `It is imperative to discuss potential risks with your healthcare provider to make an informed decision before any cosmetic procedure.`;

// Per-category banner images. Each category has its own visual identity.
export const CATEGORY_BANNERS = {
  botox: "https://images.pexels.com/photos/3997989/pexels-photo-3997989.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  "ha-filler": "https://images.pexels.com/photos/3985163/pexels-photo-3985163.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  "body-filler": "https://images.pexels.com/photos/5069430/pexels-photo-5069430.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  lipolysis: "https://images.pexels.com/photos/4046316/pexels-photo-4046316.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  "skin-booster": "https://images.pexels.com/photos/3762871/pexels-photo-3762871.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  exosome: "https://images.pexels.com/photos/3735709/pexels-photo-3735709.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  "iv-therapy": "https://images.pexels.com/photos/4226119/pexels-photo-4226119.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  "lidocaine-cream": "https://images.pexels.com/photos/3762879/pexels-photo-3762879.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
  etc: "https://images.pexels.com/photos/4226215/pexels-photo-4226215.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600&h=600&fit=crop",
};

// Back-compat default
export const CATEGORY_BANNER = CATEGORY_BANNERS.botox;

export const CATEGORY_CONTENT = {
  botox: {
    headline: "Botulinum Toxin",
    intro: "Neurotoxin injectables temporarily relax facial muscles to smooth dynamic wrinkles — crow's feet, frown lines and forehead creases. Administered by trained professionals, results typically appear within 3-7 days and last 3-4 months.",
    sections: [
      {
        title: "Why is botulinum toxin used?",
        body: "Dynamic wrinkles form from repeated muscle movements over years. By selectively relaxing those muscles, botulinum toxin softens existing lines and prevents new ones from forming.",
      },
      {
        title: "Common treatment areas",
        bullets: [
          "Glabella (frown lines between eyebrows)",
          "Forehead horizontal lines",
          "Crow's feet around the eyes",
          "Bunny lines on the nose bridge",
          "Masseter slimming for jawline definition",
          "Neck platysmal bands",
        ],
      },
      {
        title: "Available brands at wholesale",
        body: "We stock the leading Korean and global neurotoxins: Botulax, Nabota, Meditoxin, Innotox, Hutox, Liztox, Re N Tox, Coretox, Xeomin, Dysport, and Allergan Botox Cosmetic.",
      },
      {
        title: "Onset and duration",
        body: "Most patients notice softening at day 3, with full effect at day 10-14. Results typically last 3-4 months, after which top-up injections maintain the look.",
      },
    ],
  },
  "ha-filler": {
    headline: "Hyaluronic Acid Fillers",
    intro: "Dermal fillers, also known as facial injectables, offer a swift solution to diminish wrinkles and smooth fine lines on your face. These skin rejuvenating substances come in various types, catering to different needs and results. Frequently administered around the eyes, nose, and mouth regions by certified healthcare professionals, dermal fillers promise to deliver immediate and enduring results, lasting from several months to years.",
    sections: [
      {
        title: "Why are dermal fillers used?",
        body: "As the aging process unfolds, the body gradually loses collagen — a vital component present in your skin, muscles, bones, and connective tissues. The decline in collagen levels leads to skin laxity, characterized by a loss of firmness and volume. Consequently, the skin becomes thinner, less elastic, and begins to sag.",
        bullets: [
          "Restoring volume to sagging skin",
          "Enhancing facial symmetry",
          "Amplifying lips and cheeks",
          "Smoothing wrinkles and facial lines",
        ],
      },
      {
        title: "Types of HA fillers we carry",
        body: "HA filler thickness (G-prime) determines whether a product is best for deep volumization or fine surface lines. Our catalog covers all densities: deep/sub-Q for cheeks and chin, medium-density for nasolabial folds, and fine-particle for tear trough and lip lines.",
      },
      {
        title: "Popular brands",
        body: "Juvederm, Restylane, Belotero, Revolax, Neuramis, Hyaldew, Dermalax, Chaeum Premium, Yvoire, Elasty, Sardenya, Regenovue and more.",
      },
      {
        title: "Benefits",
        bullets: [
          "Immediate results — visible the same day",
          "Quick procedure — usually under an hour",
          "Minimal downtime",
          "Long-lasting effects (6-18 months)",
          "Reversible with hyaluronidase if needed",
        ],
      },
      { title: "Risks", body: COMMON_RISKS },
    ],
  },
  "body-filler": {
    headline: "Body & Biostimulator Fillers",
    intro: "Biostimulators are next-generation injectables that gradually rebuild your patient's own collagen — restoring volume, structure and natural-looking lift that develops slowly over weeks and lasts up to 25 months.",
    sections: [
      {
        title: "How biostimulators work",
        body: "Unlike traditional HA fillers that simply fill volume, biostimulators trigger your body's own collagen production. Visible improvements appear gradually over 4-6 weeks, with full results developing across a series of 2-3 sessions spaced 4 weeks apart.",
      },
      {
        title: "Available biostimulators",
        bullets: [
          "Sculptra (Poly-L-Lactic Acid / PLLA) — 25-month duration",
          "Aesthefill (PDLA) — Korean collagen biostimulator",
          "Juvelook (PDLA + HA hybrid)",
          "Gouri (PCL) — first liquid PCL biostimulator",
          "Olidia, Maxy Fill, Sedy Fill — Korean PCL options",
        ],
      },
      {
        title: "Best treatment areas",
        body: "Mid-face volume restoration, cheek augmentation, jawline contouring, post-weight-loss skin laxity, décolleté rejuvenation, and body areas including buttocks, upper arms and thighs.",
      },
      { title: "Risks", body: COMMON_RISKS },
    ],
  },
  lipolysis: {
    headline: "Lipolysis & Fat Dissolving",
    intro: "Injectable lipolysis treatments dissolve localized fat deposits without surgery. Sessions are repeated every 4-6 weeks and gradually reduce stubborn fat pockets that don't respond to diet and exercise.",
    sections: [
      {
        title: "How it works",
        body: "Phosphatidylcholine and deoxycholate solutions emulsify fat cells, which are then naturally metabolized and excreted by the body. Multiple sessions are typically required for visible contouring.",
      },
      {
        title: "Treatment areas",
        bullets: [
          "Submental fullness (double chin)",
          "Bra rolls and back fat",
          "Abdominal contouring",
          "Inner thigh and saddlebags",
          "Knee fat pads",
          "Jowls and lower-face slimming (V-line products)",
        ],
      },
      {
        title: "Our catalog",
        body: "Lipo Lab, Lipo Lab V-Line, Curenex Lipo, Lipo Vela, Kabelline, Saxenda (liraglutide) — covering both classic PPC-based lipolysis and GLP-1 weight management injectables.",
      },
      { title: "Risks", body: COMMON_RISKS },
    ],
  },
  "skin-booster": {
    headline: "Skin Boosters",
    intro: "Skin boosters deliver micro-doses of hyaluronic acid, polynucleotides and growth factors deep into the dermis to restore hydration, improve texture and stimulate cellular regeneration.",
    sections: [
      {
        title: "Why skin boosters",
        body: "Unlike fillers that add volume, boosters improve skin quality — hydration, elasticity, glow and fine lines. Ideal for patients in their 20s-30s as preventive care, and 40s+ as maintenance.",
      },
      {
        title: "Hero ingredients",
        bullets: [
          "Hyaluronic acid (Hyaron, Kiara Reju)",
          "Polynucleotides / PN (Rejuran Healer, Rejuran HB, Rejuran S/I)",
          "Salmon DNA fragments",
          "Peptide complexes (Curenex Glow, Snow Peel)",
          "Lapuroon Aurora multi-action boosters",
        ],
      },
      {
        title: "Treatment cadence",
        body: "A typical course is 3-4 sessions spaced 2-4 weeks apart, followed by maintenance every 4-6 months.",
      },
      { title: "Risks", body: COMMON_RISKS },
    ],
  },
  exosome: {
    headline: "Exosome Therapy",
    intro: "Exosomes are extracellular vesicles loaded with growth factors and signalling molecules. Combined with micro-needling, RF or fractional lasers, they accelerate healing and amplify treatment outcomes.",
    sections: [
      {
        title: "Why exosomes",
        body: "Exosomes carry concentrated regenerative signals — they 'tell' nearby cells to repair, regenerate and produce collagen. Post-laser recovery is dramatically faster, and hair restoration outcomes improve at 3-6 months.",
      },
      {
        title: "Our exosome line",
        bullets: [
          "ASCE+ SRLV-S — skin rejuvenation",
          "ASCE+ HRLV — hair restoration",
          "Hairna Exosome Hair Fill — scalp microneedling protocol",
        ],
      },
      {
        title: "Best paired with",
        body: "Fractional lasers, microneedling, RF microneedling, hair PRP, post-procedure recovery protocols.",
      },
      { title: "Risks", body: COMMON_RISKS },
    ],
  },
  "iv-therapy": {
    headline: "IV Therapy",
    intro: "Intravenous wellness infusions deliver vitamins, antioxidants and amino acids directly into the bloodstream for maximum bioavailability.",
    sections: [
      {
        title: "Our IV catalog",
        body: "We stock pharmaceutical-grade injectable ascorbic acid (vitamin C) and other infusion-ready formulations for clinical wellness programs.",
      },
    ],
  },
  "lidocaine-cream": {
    headline: "Topical Anesthetic Creams",
    intro: "Professional-grade topical lidocaine creams provide effective numbing for injectable, laser and microneedling procedures.",
    sections: [
      {
        title: "Our pick",
        body: "J-CAIN Cream — Korean professional-strength lidocaine cream sold in 500g tubs. Applied 20-30 minutes before procedure for optimal patient comfort.",
      },
    ],
  },
  etc: {
    headline: "Accessories & Supplies",
    intro: "Essential supplies for any aesthetic clinic — emergency hyaluronidase, professional lidocaine injectables and cannulas.",
    sections: [
      {
        title: "What's in stock",
        bullets: [
          "Liporase (hyaluronidase) — for filler dissolution and emergency",
          "Lignospan 2% — dental-grade lidocaine for nerve blocks",
          "Huons Lidocaine HCl — injectable local anesthetic",
        ],
      },
    ],
  },
};

export const FREE_SHIPPING_THRESHOLD = 699;
